import { Navigate, Route, Routes } from "react-router-dom";

import { LoginPage } from "../../features/auth/pages/LoginPage";
import { ProtectedRoute } from "../../features/auth/components/ProtectedRoute";
import { CustomerHomePage } from "../../features/home/pages/CustomerHomePage";
import { ProposalView } from "../../features/home/components/ProposalView";
import { ProfileView } from "../../features/home/components/ProfileView";
import { MainLayout } from "../layout/MainLayout";
import { PATHS } from "./paths";
import OrderView from "../../features/home/components/OrderView";
import { OrderCreatePage } from "../../features/orders/pages/OrderCreatePage";
import { OrderConfirmPage } from "../../features/orders/pages/OrderConfirmPage";
import { OrderDetailPage } from "../../features/orders/pages/OrderDetailPage";
import { ProposalDetailPage } from "../../features/proposal/pages/ProposalDetailPage";

export const AppRoutes = () => (
  <Routes>
    <Route path={PATHS.AUTH.LOGIN} element={<LoginPage />} />
    <Route element={<ProtectedRoute />}>
      <Route element={<MainLayout />}>
        <Route index element={<Navigate to={PATHS.ORDERS} replace />} />
        <Route path={PATHS.HOME} element={<CustomerHomePage />} />
        <Route path={PATHS.ORDERS} element={<OrderView />} />
        <Route path={PATHS.PROPOSAL} element={<ProposalView />} />
        <Route path={PATHS.PROFILE} element={<ProfileView />} />
      </Route>

      <Route path={PATHS.ORDER_DETAIL} element={<OrderDetailPage />} />
      <Route path={PATHS.ORDER_CREATE} element={<OrderCreatePage />} />
      <Route path={PATHS.ORDER_CONFIRM} element={<OrderConfirmPage />} />
      <Route path={PATHS.PROPOSAL_DETAIL} element={<ProposalDetailPage />} />
    </Route>
    <Route path="*" element={<Navigate to={PATHS.ORDERS} replace />} />
  </Routes>
);
